import React from 'react';
import Text from '../Text';
import painter from './images/painter.svg';
import Link from '../Link';
import defaultWebSiteImage from './images/defaultWebSiteImage.png';
import './WebsiteCreateCard.less';

type WebsiteCreateCardProps = {
  title?: string;
  description?: string;
  hrefText?: string;
  href?: string;
  height?: string;
  target?: string;
  onClick?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const TWebsiteCreateCard: React.FC<WebsiteCreateCardProps> = ({
  title,
  description,
  height,
  hrefText,
  href,
  target,
}) => {
  return (
    <div style={{ height: `${height}` }} className="t-website-create-card">
      <div className="t-website-info-wrapper">
        <img src={painter} alt="painter" />
        <div className="t-website-info-text-wrapper">
          <Text textColor="primary" rows={1} level={1} paddingBottom={3} bold>
            {title}
          </Text>
          <Text textColor="dark-100" level={3} rows={2} paddingBottom={1}>
            {description}
          </Text>
          <Text underline textColor="primary" level={3} rows={2}>
            <Link href={href} title={hrefText} target={target} />
          </Text>
        </div>
      </div>
      <div className="t-website-image-wrapper">
        <img src={defaultWebSiteImage} />
      </div>
    </div>
  );
};

export default TWebsiteCreateCard;
